import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaInfoPopupComponent } from './viva-info-popup.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    VivaInfoPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    VivaInfoPopupComponent
  ]
})
export class  VivaInfoPopupModule { }
